import { fn_change_step } from "../function/FnBodyStep";
import { fn_deliveryCallFail, fn_deliveryCancelFail } from "../function/FnBodyLayer";
import { Fn_activeAxios } from "../function/FnConfig";
import { Fn_activeAxiosEtc } from "../function/FnConfigEtc";
import { fn_closeDetailView } from "../function/FnBodyDetail";
import { reload_order_list_all } from "./OrderConn";

//TPAY 배달비조회
export async function fn_search_tpay_fee(rootStore, detail = false) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;
  const deliveryStore = rootStore.deliveryStore;
  const extDetail = rootStore.deliveryStore.getExtDetail;
  const selectedAddr = rootStore.viewStore.getSelectedAddr;

  let data = JSON.stringify({
    DLV_STATUS: "0",
    DLV_STORE_CODE: "OKPOS-" + searchStore.getShopCd,
    DLV_SHOP_ADDR: searchStore.getSession.shopAddr,
    DLV_ORDER_ADDR: viewStore.getOrderDetail.dlvAddr,
    DLV_ORDER_DETAIL_ADDR: viewStore.getOrderDetail.dlvAddrDetail,
    DLV_ORDER_AMT: viewStore.getOrderDetail.orderAmount,
    DLV_ORDER_X: selectedAddr.x,
    DLV_ORDER_Y: selectedAddr.y,
  });

  const api = Fn_activeAxiosEtc(rootStore);
  let response = await api
    .post("/tpayDlv/okPos/call", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + rootStore.settingStore.ActiveRestUrl.tpayToken,
        DLV_TP: extDetail.delivery_code,
      },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.header.RES_CODE === "200") {
          let data = res.data.body;

          data.pick_arr = rootStore.deliveryStore._st_delivery_fee.pick_arr;
          if (data) {
            data = { ...data, delivery_fee: data.DLV_CHARGE };
            deliveryStore.setDeliveryFee(data);
            let newData = { ...data, delivery_code: extDetail.delivery_code };
            deliveryStore.setExpDeliveryFee(newData);
            //deliveryStore.setDeliveryListFee(extDetail.delivery_code, data.delivery_fee);
            deliveryStore.setDeliveryListFee(extDetail.delivery_code, data.delivery_fee, data.STORE_CASH);
            if (detail) {
              deliveryStore.setDeliveryDetailFee(data.delivery_fee);
            }
            return "1";
          }
        } else {
          rootStore.layerStore.setDeliveryErrMsg(res.data.header.RES_MSG);
          return "0";
        }
      } else {
        return "0";
      }
    })
    .catch(err => {
      return "0";
    });

  return response;
}

// 배달 요청
export function fn_tpay_request(rootStore) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;
  const deliveryStore = rootStore.deliveryStore;
  const extDetail = rootStore.deliveryStore.getExtDetail;
  const selectedAddr = rootStore.viewStore.getSelectedAddr;
  let deliverySelectedIndex = rootStore.deliveryStore.getExtDetail;
  let pre_pay_type = "N";
  if (viewStore.getOrderDetail.payType === "PAID") {
    pre_pay_type = "Y";
  }

  let pay_type = "Q";
  if (viewStore.getOrderDetail.payFg === "CASH") {
    pay_type = "C";
  } else if (viewStore.getOrderDetail.payFg === "CARD") {
    pay_type = "D";
  }

  let data = {
    shopCd: searchStore.getShopCd,
    saleDate: viewStore.getOrderDetail.saleDate,
    orderNo: viewStore.getOrderDetail.orderNo,
    //posNo: viewStore.getOrderDetail.posNo,
    posNo: searchStore.getSession.connPosNo,
    mobileOrderNo: viewStore.getOrderDetail.mobileOrderNo,
    payAmount: viewStore.getOrderDetail.orderAmount,
    reqTime: viewStore.getOrderDetail.orderTime,
    cookTime: deliveryStore.getExtDetail.delivery_time,
    destRoadAddr: viewStore.getOrderDetail.dlvAddr,
    destRoadAddrDetail: viewStore.getOrderDetail.dlvAddrDetail,
    fee: deliveryStore.getDeliveryFee.delivery_fee,
    goods: viewStore.getOrderDetail.viewProdNm,
    orderMemo: viewStore.getOrderDetail.dlvMessage,
    storeMemo: viewStore.getOrderDetail.shopMessage,
    //orderMemo: viewStore.getOrderDetail.shopMessage,
    orderTelNo: viewStore.getOrderDetail.cstTelNo ? viewStore.getOrderDetail.cstTelNo : "",
    partnerCode: extDetail.delivery_code,
    partnerName: extDetail.delivery_name,
    payType: pay_type,
    prePayAmt: viewStore.getOrderDetail.gstPayAmt,
    prePayType: pre_pay_type,
    shopAddr: searchStore.getSession.shopAddr,
    shopTelNo: "",
    //storeMemo: viewStore.getOrderDetail.dlvMessage,
    destLat: viewStore.getOrderDetail.targetLat != null ? viewStore.getOrderDetail.targetLat : selectedAddr.y,
    destLng: viewStore.getOrderDetail.targetLng != null ? viewStore.getOrderDetail.targetLng : selectedAddr.x,
  };

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/tpay/regist", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;

          if (data && data.header && data.header.RES_CODE === "200") {
            fn_change_step(rootStore, "500");
            rootStore.layerStore.setLayerDeliveryCall(false); // 배달요청 레이어 닫기
          } else {
            rootStore.layerStore.setDeliveryErrMsg(data.header.RES_MSG);
            fn_deliveryCallFail(rootStore);
          }
        } else {
          fn_deliveryCallFail(rootStore);
        }
      } else {
        fn_deliveryCallFail(rootStore);
      }
    })
    .catch(err => {
      fn_deliveryCallFail(rootStore);
    })
    .finally(() => {
      //rootStore.layerStore.setLayerDeliveryCall(false);       // 배달요청 레이어 닫기
      rootStore.deliveryStore.initDeliveryListFee(); // 배달비 초기화
      rootStore.deliveryStore.setExpDelivery(rootStore.deliveryStore.getExpDelivery); // 배달대행사 0번째 지정
    });
}

// 배달 취소
export function tpay_cancel(rootStore, mobileOrderNo) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    saleDate: searchStore.getSaleDate,
    orderNo: viewStore.getOrderDetail.orderNo,
    mobileOrderNo: viewStore.getOrderDetail.mobileOrderNo,
    partnerCode: viewStore.getOrderDetail.dlvPtnerCd,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/tpay/cancel", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data && data.header && data.header.RES_CODE === "200") {
            reload_order_list_all(rootStore);
            fn_change_step(rootStore, "200");
          } else {
            rootStore.layerStore.setDeliveryErrMsg(data.header.RES_MSG);
            fn_deliveryCallFail(rootStore);
          }
        } else {
          fn_deliveryCancelFail(rootStore);
        }
      } else {
        fn_deliveryCancelFail(rootStore);
      }
    })
    .catch(err => {
      fn_deliveryCancelFail(rootStore);
    })
    .finally(() => {
      fn_closeDetailView(rootStore);
      rootStore.layerStore.setLayerDeliveryCall(false); // 배달요청 레이어 닫기
      rootStore.deliveryStore.initDeliveryListFee(); // 배달비 초기화
      rootStore.deliveryStore.setExpDelivery(rootStore.deliveryStore.getExpDelivery); // 배달대행사 0번째 지정
    });
}
